import { useEventCallback } from '@mui/material';
import { memo } from 'react';
import { DateTimePicker as DateTimePickerMaterial, DateTimePickerProps } from '@mui/lab';
import { DateTime } from 'luxon';

export type PmiDateTimePickerProps = DateTimePickerProps<DateTime> & { defaultHour?: DateTime };

const DateTimePickerComponent = ({
  defaultHour,
  ...props
}: PmiDateTimePickerProps): React.ReactElement => {
  const onBlur = useEventCallback((e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    props?.InputProps?.onBlur?.(e);

    // Recupera il testo visibile nell'input (es. "30/10/2026 ")
    const rawText = e.target.value?.trim();
    const currentValue = (props.value || null) as DateTime;

    // Se l'oggetto è invalido ma l'utente ha scritto qualcosa
    if ((!currentValue || !currentValue?.isValid) && rawText) {
      // Prova a fare il parsing solo dei primi 10 caratteri (GG/MM/AAAA)
      const dateOnlyText = rawText.substring(0, 10);
      const parsedDate = DateTime.fromFormat(dateOnlyText, 'dd/MM/yyyy');

      if (parsedDate.isValid) {
        // Imposta l'orario a 00:00
        const finalDateTime = parsedDate.set({
          hour: defaultHour?.get('hour'),
          minute: defaultHour?.get('minute'),
          second: defaultHour?.get('second'),
          millisecond: defaultHour?.get('millisecond'),
        });
        props.onChange(finalDateTime);
      }
    }
  });

  return (
    <DateTimePickerMaterial
      InputProps={{
        ...props.InputProps,
        onBlur,
      }}
      {...props}
    />
  );
};

DateTimePickerComponent.displayName = 'DateTime Picker component';

export const PmiDateTimePicker = memo(DateTimePickerComponent) as typeof DateTimePickerComponent;

export default PmiDateTimePicker;
